"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.smoothScrollToX = exports.safeScrollLeft = exports.getCTAData = exports["default"] = exports.checkIEVersion = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _types = require("./types");
var ie12 = 12;
var ie11 = 11;
var ieVersion = -1;
var isFirefox = false;
var isSafari = false;
var checkIEVersion = function checkIEVersion() {
  var currentVersion = -1; // Return value assumes failure.
  var _ref = typeof window !== 'undefined' && window.navigator,
    appName = _ref.appName;
  var _ref2 = typeof window !== 'undefined' && window.navigator,
    appVersion = _ref2.appVersion;
  var _ref3 = typeof window !== 'undefined' && window.navigator,
    userAgent = _ref3.userAgent;
  if (appName === 'Microsoft Internet Explorer') {
    var msieRegExp = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})');
    if (msieRegExp.exec(userAgent) !== null) {
      currentVersion = parseFloat(RegExp.$1);
    }
  } else if (appName === 'Netscape' && (appVersion.indexOf('Edge') !== -1 || appVersion.indexOf('Trident') !== -1)) {
    if (appVersion.indexOf('Trident') === -1) {
      currentVersion = ie12;
    } else {
      currentVersion = ie11;
    }
  }
  return currentVersion;
};

// Smooth scroll support for Safari
exports.checkIEVersion = checkIEVersion;
var smoothScrollToX = function smoothScrollToX(scrollTargetX, el) {
  if (scrollTargetX === void 0) {
    scrollTargetX = 0;
  }
  var scrollX = el.scrollX || el.scrollLeft;
  var speed = 2500;
  var currentTime = 0;
  var easingFunction = function easingFunction(pos) {
    return -0.5 * (Math.cos(Math.PI * pos) - 1); // eslint-disable-line no-magic-numbers
  };
  var time = Math.max(0.1, Math.min(Math.abs(scrollX - scrollTargetX) / speed, 0.8)); // eslint-disable-line no-magic-numbers

  var tick = function tick() {
    currentTime += 1 / 60; // eslint-disable-line no-magic-numbers

    var p = currentTime / time;
    var t = easingFunction(p);
    if (p < 1 && typeof window !== 'undefined') {
      window.requestAnimationFrame(tick);
      el.scrollTo(scrollX + (scrollTargetX - scrollX) * t, 0);
    } else {
      el.scrollTo(scrollTargetX, 0);
    }
  };
  tick();
};
exports.smoothScrollToX = smoothScrollToX;
var safeScrollLeft = function safeScrollLeft(desiredPosition, el) {
  var element = el;
  if (!element) return;
  if (ieVersion === ie11 || ieVersion === ie12) {
    element.scrollLeft = desiredPosition;
  } else if (isSafari) {
    smoothScrollToX(desiredPosition, element);
  } else {
    element.scrollTo({
      top: 0,
      left: desiredPosition,
      behavior: 'smooth'
    });
  }
};
exports.safeScrollLeft = safeScrollLeft;
var getCTAData = function getCTAData(item) {
  var priority = 'trivial';
  if (! /*#__PURE__*/_react["default"].isValidElement(item) && typeof item === 'object' && item !== null) {
    return {
      priority: priority,
      label: item.label,
      url: item.url
    };
  }
  return {
    priority: priority,
    label: item
  };
};
exports.getCTAData = getCTAData;
var BaseHorizontalList = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(BaseHorizontalList, _React$Component);
  function BaseHorizontalList() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = BaseHorizontalList.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var handleControls = this.handleControls,
      listWrapper = this.listWrapper;
    this.setRotatedControls();
    listWrapper.current.addEventListener('scroll', handleControls, true);
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleControls, true);
    }
    setTimeout(function () {
      handleControls();
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var handleControls = this.handleControls,
      listWrapper = this.listWrapper;
    listWrapper.current.removeEventListener('scroll', handleControls);
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', handleControls, true);
    }
  };
  _proto.handleControls = function handleControls() {
    var _this$props = this.props,
      showSelectMenuIfScrollable = _this$props.showSelectMenuIfScrollable,
      showDropdownMenuIfScrollable = _this$props.showDropdownMenuIfScrollable,
      showSelectMenuAllBreakpoints = _this$props.showSelectMenuAllBreakpoints,
      _this$listWrapper$cur = this.listWrapper.current,
      scrollWidth = _this$listWrapper$cur.scrollWidth,
      clientWidth = _this$listWrapper$cur.clientWidth,
      scrollLeft = _this$listWrapper$cur.scrollLeft,
      isRTL = this.isRTL;
    // Adding a 10px tolerance to scrolling to the end
    var padding = 20;
    var useRTLControls = isRTL && (scrollLeft < 0 || isFirefox || isSafari);
    if (clientWidth > 0 || showSelectMenuAllBreakpoints === true) {
      var scrolledToEndOfLinksDiv = scrollLeft + clientWidth > scrollWidth - padding;
      var hasScrolled = scrollLeft > 0;
      var isScrollable = scrollWidth > clientWidth;
      var leftArrowDisplay = isScrollable && hasScrolled || scrolledToEndOfLinksDiv ? 'show' : 'hide';
      var rightArrowDisplay = !scrolledToEndOfLinksDiv ? 'show' : 'hide';
      var controlsDisplay = isScrollable ? 'show' : 'hide';
      var selectMenuDisplay = showSelectMenuIfScrollable && isScrollable ? 'show' : 'hide';
      var dropdownMenuDisplay = showDropdownMenuIfScrollable && isScrollable ? 'show' : 'hide';
      var horizontalListDisplayState = selectMenuDisplay === 'show' || dropdownMenuDisplay === 'show' ? 'hide' : 'show';
      var horizontalListDisplay = !showSelectMenuIfScrollable && !showDropdownMenuIfScrollable ? 'show' : horizontalListDisplayState;
      var horizontalListOpacity = 'noTransparent';
      if (useRTLControls) {
        scrolledToEndOfLinksDiv = Math.abs(scrollLeft - clientWidth) > scrollWidth - padding;
        hasScrolled = scrollLeft < -1;
        rightArrowDisplay = isScrollable && hasScrolled || scrolledToEndOfLinksDiv ? 'show' : 'hide';
        leftArrowDisplay = !scrolledToEndOfLinksDiv ? 'show' : 'hide';
      }
      if (typeof window !== 'undefined' && showSelectMenuAllBreakpoints === true) {
        var listItems = this.listWrapper.current.childNodes;
        var lastItemBoundingRect = null;
        var currentListWidth = 0;
        if (listItems) {
          lastItemBoundingRect = listItems[listItems.length - 1].getBoundingClientRect();
          currentListWidth = lastItemBoundingRect.x + lastItemBoundingRect.width;
          if (this.listWidth === 0 || currentListWidth !== 0 && this.listWidth > currentListWidth) {
            this.listWidth = currentListWidth;
          }
          if (window.innerWidth - 100 > this.listWidth) {
            selectMenuDisplay = 'hide';
            dropdownMenuDisplay = 'hide';
            horizontalListDisplay = 'show';
          } else {
            selectMenuDisplay = 'show';
            dropdownMenuDisplay = 'show';
            horizontalListDisplay = 'hide';
          }
        }
      }
      this.setState({
        leftArrowDisplay: leftArrowDisplay,
        rightArrowDisplay: rightArrowDisplay,
        controlsDisplay: controlsDisplay,
        isScrollable: isScrollable,
        selectMenuDisplay: selectMenuDisplay,
        dropdownMenuDisplay: dropdownMenuDisplay,
        horizontalListDisplay: horizontalListDisplay,
        horizontalListOpacity: horizontalListOpacity
      });
    }
  };
  _proto.onArrowClickBack = function onArrowClickBack() {
    this.triggerScrollMovement('back');
  };
  _proto.onArrowClickForward = function onArrowClickForward() {
    this.triggerScrollMovement('forward');
  };
  _proto.setRotatedControls = function setRotatedControls() {
    this.setState({
      useRotatedControls: this.isRTL && (ieVersion === ie11 || ieVersion === ie12)
    });
  };
  _proto.triggerScrollMovement = function triggerScrollMovement(direction) {
    var current = this.listWrapper.current;
    var clientWidth = current.clientWidth,
      scrollLeft = current.scrollLeft;
    var distance = direction === 'back' ? scrollLeft - clientWidth : scrollLeft + clientWidth;

    // scroll same distance as viewport width of links div
    safeScrollLeft(distance, current);
  };
  _proto.isDisabledTab = function isDisabledTab(index) {
    var disabledTabs = this.props.disabledTabs;
    if (disabledTabs && Array.isArray(disabledTabs) && disabledTabs.includes(index)) return true;
    return false;
  };
  return BaseHorizontalList;
}(_react["default"].Component);
exports["default"] = BaseHorizontalList;
BaseHorizontalList.displayName = 'BaseHorizontalList';
BaseHorizontalList.defaultProps = {
  items: [],
  activeIndex: null,
  spaceBetweenArrows: false,
  showSelectMenuIfScrollable: false,
  arrowIsDark: false,
  ariaControlsId: '0',
  onDropdownToggle: function onDropdownToggle() {
    return null;
  },
  onKeyDown: function onKeyDown() {
    return null;
  },
  onItemClick: function onItemClick() {
    return null;
  },
  showDropdownMenuIfScrollable: false,
  overviewText: ''
};